<form [formGroup]="form" [id]="id">
  <p-inputgroup>
    @if ((cacheParameters | async)?.isLoading) {
      <i class="pi spin autorenew s-loader"></i>
    }
    <p-float-label>
      @if ((displayItems$ | async)?.length === 0) {
        <input pInputText type="text" class="form-control" disabled="true" [s-blur]="attribute?.dataClassification" />
      }
      @if (fieldName && ((displayItems$ | async)?.length ?? 0) > 0) {
        <p-select
          #control
          appendTo="body"
          [formControlName]="fieldName.toString()"
          class="form-control"
          [required]="!!required"
          [options]="(displayItems$ | async) ?? undefined"
          [optionLabel]="displayProperty"
          [dropdownIcon]="readonly ? 'pi lock' : undefined"
          optionValue="id"
          [showClear]="showClear ?? !required"
          (onChange)="onChange()"
          [readonly]="readonly"
        />
      }
      @if ((fieldName === null || fieldName === undefined) && ((displayItems$ | async)?.length ?? 0) > 0) {
        <p-select
          #control
          [(ngModel)]="nonFormValue"
          [ngModelOptions]="{ standalone: true }"
          appendTo="body"
          class="form-control"
          [required]="!!required"
          [options]="(displayItems$ | async) ?? undefined"
          [optionLabel]="displayProperty"
          optionValue="id"
          [showClear]="showClear ?? !required"
          (onChange)="onChange()"
          [readonly]="readonly"
        />
      }
      <label for="control" [class.invalid]="myControl?.invalid && myControl?.touched"
        >{{ label }}
        @if (attribute?.displayNameSuffixIcon) {
          <i inline style="font-size: small"> {{ attribute?.displayNameSuffixIcon }}</i>
        }
        @if (required) {
          <span style="color: red">*</span>
        }
      </label>
    </p-float-label>
    <ng-content></ng-content>
  </p-inputgroup>
  @if (displayHint || attribute?.displayHint) {
    <small class="block">
      {{ displayHint ? displayHint : attribute?.displayHint }}
    </small>
  }
  <s-form-error-input
    [groupName]="groupName"
    [fieldName]="fieldName"
    [form]="form"
    [apiError]="apiError"
    [schema]="schema"
  />
</form>

<!-- [dropdownIcon]="(cacheParameters | async)?.isLoading ? 'pi spin autorenew s-loader' : 'pi pi-chevron-down'" -->
